import { render, staticRenderFns } from "./ArticleBlock.vue?vue&type=template&id=423ca461&scoped=true"
import script from "./ArticleBlock.vue?vue&type=script&lang=js"
export * from "./ArticleBlock.vue?vue&type=script&lang=js"
import style0 from "./ArticleBlock.vue?vue&type=style&index=0&id=423ca461&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423ca461",
  null
  
)

export default component.exports